export default "__VITE_ASSET__WPxlm_hl__"